import {initialState} from '@ispm-client/modules/pathways/store/state';
import {
  PathwayProgressionActions,
  PathwayActionTypes
} from '@ispm-client/modules/pathways/store/actions/pathway-test.actions';
import {Progression} from '@ispm-shared/modules/common';

export function pathwayTestProgression(state = initialState.pathwayTestProgression, action: PathwayProgressionActions): Progression {
  switch (action.type) {
    case PathwayActionTypes.UPDATE_PATHWAY_TEST_PROGRESSION:
      return action.payload.progression;
    case PathwayActionTypes.UPDATE_PATHWAY_TEST_FINAL_PROGRESSION:
      return action.payload.progression;
    default: {
      return state;
    }
  }
}
